import Vue from 'vue'
import Router from 'vue-router'

const _import = require('./_import_' + process.env.NODE_ENV)
/* layout */
import Layout from '@/components/layout/Layout'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: _import('login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home/home_index',
    name: '默认跳转页面',
    hidden: true
  },
  {
    path: '/404',
    component: _import('errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: _import('errorPage/401'),
    hidden: true
  }
]

export const asyncRouterMap = [
  {
    path: '/home',
    component: Layout,
    name: '首页',
    meta: 'meta_common', 
    sidebarShow: false,
    children: [
      { path: 'home_index', name: '首页显示页面', meta: 'meta_common', component: _import('home/index')},
    ],
  },
  {
    path: '/act',
    component: Layout,
    name: '活动管理',
    hidden: true,
    meta: 'meta_common', 
    sidebarShow: true, 
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_data.png',
    children: [
      { rootpath:'act', path:'act_submenu_info', parentName:'', meta: 'meta_common', name: '活动信息'},
      { rootpath:'act', path:'act_submenu_info_base', parentName:'act_submenu_info', meta: 'meta_common', name: '基础信息', component: _import('act/base') },
      { rootpath:'act', path:'act_submenu_info_rule', parentName:'act_submenu_info', meta: 'meta_common', name: '规则设置', component: _import('act/ruleSet') },
      { rootpath:'act', path:'act_submenu_info_money', parentName:'act_submenu_info', meta: 'meta_common', name: '红包设置', component: _import('act/money') },
      { rootpath:'act', path:'act_submenu_info_share', parentName:'act_submenu_info', meta: 'meta_common', name: '分享设置', component: _import('act/share') },
      { rootpath:'act', path:'act_submenu_content', parentName:'', meta: 'meta_common', name: '内容'},
      { rootpath:'act', path:'act_submenu_content_notice', parentName:'act_submenu_content', meta: 'meta_common', name: '活动须知', component: _import('act/notice') },
      { rootpath:'act', path:'act_submenu_content_rule', parentName:'act_submenu_content', meta: 'meta_common', name: '活动规则', component: _import('act/rule') },
      { rootpath:'act', path:'act_submenu_content_result', parentName:'act_submenu_content', meta: 'meta_common', name: '中奖结果', component: _import('act/result') },
      { rootpath:'act', path:'act_submenu_prize', parentName:'', meta: 'meta_common', name: '奖品'},
      { rootpath:'act', path:'act_submenu_prize_prize0', parentName:'act_submenu_prize', meta: 'meta_common', name: '未中奖配置', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize1', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品一', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize2', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品二', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize3', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品三', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize4', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品四', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize5', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品五', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize6', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品六', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize7', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品七', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize8', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品八', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize9', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品九', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize10', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品十', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize11', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品十一', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize12', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品十二', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_prize13', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品十三', component: _import('act/prize') },
      { rootpath:'act', path:'act_submenu_prize_cardRate', parentName:'act_submenu_prize', meta: 'meta_common', name: '集卡中奖率', component: _import('act/cardRate') },
      { rootpath:'act', path:'act_submenu_prize_rate', parentName:'act_submenu_prize', meta: 'meta_common', name: '奖品中奖率', component: _import('act/rate') },
      { rootpath:'act', path:'act_submenu_skin', parentName:'', meta: 'meta_common', name: '皮肤定制'},
      { rootpath:'act', path:'act_submenu_skin_bg', parentName:'act_submenu_skin', meta: 'meta_common', name: '背景图', component: _import('act/bgImg') },
      { rootpath:'act', path:'act_submenu_skin_tool', parentName:'act_submenu_skin', meta: 'meta_common', name: '营销工具', component: _import('act/toolImg') },
      { rootpath:'act', path:'act_submenu_skin_guide', parentName:'act_submenu_skin', meta: 'meta_common', name: '首页引导', component: _import('act/guideImg') },
      { rootpath:'act', path:'act_submenu_skin_prize', parentName:'act_submenu_skin', meta: 'meta_common', name: '我的奖品', component: _import('act/myPrizeImg') },
      { rootpath:'act', path:'act_submenu_skin_page', parentName:'act_submenu_skin', meta: 'meta_common', name: '中奖页', component: _import('act/winningImg') },
      { rootpath:'act', path:'act_submenu_skin_rule', parentName:'act_submenu_skin', meta: 'meta_common', name: '活动规则', component: _import('act/rulesImg') },
      { rootpath:'act', path:'act_submenu_skin_game', parentName:'act_submenu_skin', meta: 'meta_common', name: '游戏页', component: _import('act/gameImg') },
      { rootpath:'act', path:'act_submenu_skin_result', parentName:'act_submenu_skin', meta: 'meta_common', name: '结果页', component: _import('act/resultImg') },
      { rootpath:'act', path:'act_submenu_done', parentName:'', meta: 'meta_common', name: '完成发布'},
      { rootpath:'act', path:'act_submenu_done_product', parentName:'act_submenu_done', meta: 'meta_common', name: '关联产品', component: _import('act/product') }
    ]
  },
  /* {
    path: '/data',
    component: Layout,
    name: '数据驾驶舱',
    sidebarShow: true, 
    meta: 'meta_common', 
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_data.png',
    children: [
      { rootpath:'data', path: 'data_submenu_active_main', parentName:'data_submenu_active', meta: 'meta_common', name: '扫码概览', component: _import('data/active/main') },
      { rootpath:'data', path: 'data_submenu_active', parentName:'', meta: 'meta_common', name: '活动分析服务'},
      { rootpath:'data', path: 'data_submenu_active_draw', parentName:'data_submenu_active', meta: 'meta_common', name: '抽奖分析', component: _import('data/active/draw') },
      { rootpath:'data', path: 'data_submenu_active_area', parentName:'data_submenu_active', meta: 'meta_common', name: '地域分布', component: _import('data/active/area') },
      { rootpath:'data', path: 'data_submenu_active_prize', parentName:'data_submenu_active', meta: 'meta_common', name: '中奖名单', component: _import('data/active/prize') },
      { rootpath:'data', path: 'data_submenu_active_device', parentName:'data_submenu_active', meta: 'meta_common', name: '设备分析', component: _import('data/active/device') },
      { rootpath:'data', path: 'data_submenu_active_prizeStock', parentName:'data_submenu_active', meta: 'meta_common', name: '奖品库存', component: _import('data/active/prizeStock') },
      { rootpath:'data', path: 'data_submenu_active_scan', parentName:'data_submenu_active', meta: 'meta_common', name: '扫码时段', component: _import('data/active/scan') },
      { rootpath:'data', path: 'data_submenu_share', parentName:'', meta: 'meta_common', name: '裂变分析服务'},
      { rootpath:'data', path: 'data_submenu_share_baocai', parentName:'data_submenu_share', meta: 'meta_common', name: '裂变分析', component: _import('data/share/list') },
      { rootpath:'data', path: 'data_submenu_trace', parentName:'', meta: 'meta_common', name: '轻追溯服务'},
      { rootpath:'data', path: 'data_submenu_trace_baocai', parentName:'data_submenu_trace', meta: 'meta_common', name: '包装周转周期', component: _import('data/index') },
      { rootpath:'data', path: 'data_submenu_trace_chengpin', parentName:'data_submenu_trace', meta: 'meta_common', name: '成品库存周期', component: _import('data/index') },
      { rootpath:'data', path: 'data_submenu_jxs', parentName:'', meta: 'meta_common', name: '渠道分析服务'},
      { rootpath:'data', path: 'data_submenu_jxs_puhuo', parentName:'data_submenu_jxs', meta: 'meta_common', name: '铺货周期', component: _import('data/index') },
      { rootpath:'data', path: 'data_submenu_cuanhuo', parentName:'', meta: 'meta_common', name: '防窜货服务'},
      { rootpath:'data', path: 'data_submenu_cuanhuo_cuanhuo', parentName:'data_submenu_cuanhuo', meta: 'meta_common', name: '窜货地图', component: _import('data/index') },
      { rootpath:'data', path: 'data_submenu_map', parentName:'', meta: 'meta_common', name: '实时扫码热力图'},
      { rootpath:'data', path: 'data_submenu_map_index', parentName:'data_submenu_map', meta: 'meta_common', name: '实时扫码热力图', component: _import('data/map/index') },
      { rootpath:'data', path: 'data_submenu_book', parentName:'', meta: 'meta_common', name: '智能营销报告'},
      { rootpath:'data', path: 'data_submenu_book_active', parentName:'data_submenu_book', meta: 'meta_common', name: '活动运营报告', component: _import('data/book/active') },
      { rootpath:'data', path: 'data_submenu_book_industry', parentName:'data_submenu_book', meta: 'meta_common', name: '行业报告', component: _import('data/book/industry') }
    ]
  }, */
  {
    path: '/prize',
    component: Layout,
    name: '中奖名单',
    meta: 'prizeList', 
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_data.png',
    children: [
      { path: 'prize_list', sidebarShow: false, meta: 'prizeList', name: '奖品首页', component: _import('prize/list')},
    ]
  },
  {
    path: '/prize',
    component: Layout,
    name: '奖品',
    meta: 'meta_common', 
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_prize.png',
    children: [
      { path: 'prize_index', sidebarShow: false, meta: 'meta_common', name: '奖品首页', component: _import('prize/index')},
    ]
  },
  {
    path: '/tools',
    component: Layout,
    name: '营销工具',
    meta: 'meta_common', 
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_tool.png',
    children: [
      { path: 'tools_index', sidebarShow: false, meta: 'meta_common', name: '营销工具首页', component: _import('tools/index')},
    ]
  },
  {
    path: '/tag',
    component: Layout,
    name: '标签',
    meta: 'meta_common', 
    sidebarShow: true, 
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_tag.png',
    children: [
      { rootpath:'tag', path: 'tag_submenu_main_actvie', parentName:'tag_submenu_main', meta: 'meta_common', name: '活动标签', component: _import('tag/index') },
      { rootpath:'tag', path: 'tag_submenu_main', parentName:'', meta: 'meta_common', name: '标签'},
      { rootpath:'tag', path: 'tag_submenu_main_user', parentName:'tag_submenu_main', meta: 'meta_common', name: '用户标签', component: _import('tag/user') },
    ]
  },
  {
    path: '/verificate',
    component: Layout,
    name: '核销',
    meta: 'meta_verificate', 
    sidebarShow: false,
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_verificate.png',
    children: [
      { path: 'verificate_index', name: '核销首页', meta: 'meta_verificate', component: _import('verificate/index')},
    ]
  },
  {
    path: '/product',
    component: Layout,
    name: '产品',
    meta: 'meta_common', 
    sidebarShow: false,
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_product.png',
    children: [
      { path: 'product_index', name: '产品首页', meta: 'meta_common', component: _import('product/index')},
    ]
  },
  {
    path: '/present',
    component: Layout,
    name: '礼品市场',
    meta: 'meta_common', 
    sidebarShow: false,
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_gift.png',
    children: [
      { path: 'present_index', name: '礼品市场首页', meta: 'meta_common', component: _import('present/index')},
      { path: 'present_cart', name: '购物车', meta: 'meta_common', component: _import('present/cart')},
    ]
  },
  {
    path: '/liebian',
    component: Layout,
    name: '裂变中心',
    meta: 'meta_common', 
    sidebarShow: false,
    icon: 'https://cdn.greatdata.com.cn/oss/imc/icon_home_fission.png',
    children: [
      { path: 'liebian_index', name: '裂变中心首页', meta: 'meta_common', component: _import('liebian/index')},
    ]
  }, 
  {
    path: '/error',
    component: Layout,
    redirect: 'noredirect',
    hidden: true,
    name: '错误页面',
    icon: 'el-icon-circle-cross',
    children: [
      { path: '401', component: _import('errorPage/401'), name: '401' },
      { path: '404', component: _import('errorPage/404'), name: '404' }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js